export default __webpack_public_path__ + "media/images/mailer-new/common/logo-header-e0d527e427146d05238a3293d1dd0223.png";